import React from 'react'

// Third Party
import showdown from 'showdown'
import { Helmet } from 'react-helmet'
import SbEditable from 'storyblok-react'
import { withRouteData } from 'react-static'

// Project
import './FAQ.css'
import CollapsableComponent from '../components/FAQCollapsableComponent.js'

const converter = new showdown.Converter()

const BookChapters = ({ plans, story: { content } }) => {
  // const introduction = content.introduction?.[0]
  // const description = content.introduction?.[1]

  return (
    <div>
      <Helmet>
        <title>{content && content.top[0].title}</title>
      </Helmet>
      {content &&
        content.top.map(el => (
          <div
            className='hero hero--small'
            key={el._uid}
            style={{
              backgroundImage: `url(${el.image})`,
              backgroundPosition: `center ${el.image_offset ? `${el.image_offset}%` : '50%'}`,
            }}
          >
            <div className='hero__overlay' />
            <div className='wrapper'>
              <SbEditable content={el}>
                <h1 className='hero__title hero--small__title'>{el.title}</h1>
              </SbEditable>
            </div>
          </div>
        ))}

      <div className='wrapper'>
        {content.introduction && content.introduction[0] && (
          <div>
            <h2 className='text-center font-bold' style={{ fontSize: '2em' }}>
              {content.introduction[0].text}
            </h2>
            {content.introduction[1] && <p className='text-center'>{content.introduction[1].description}</p>}
          </div>
        )}

        <div className='collapsable'>
          {plans.map(plan => {
            const { contents } = plan.content

            const file = contents.find(item => item.component === 'PDF')
            const title = contents.find(item => item.component === 'Section Title').text
            const content = contents.find(item => item.component === 'Rich Text').markdown

            return <CollapsableComponent pdf={file} key={plan.id} content={content} triggerText={title} />
          })}
        </div>
      </div>
    </div>
  )
}

export default withRouteData(BookChapters)



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/BookChapters.jsx